import { Typography } from '@material-ui/core'
import AccommodationIcon from '@material-ui/icons/Apartment'
import { useParams } from 'react-router-dom'

import { getTranslate } from '../../localization'
import AccommodationAddHeaderSkeleton from './AccommodationAddHeader.Skeleton'
import useStyles from './styles/AccommodationAddHeader.styles'

type Level = {
  label: string
  link?: string
}
interface AccommodationAddHeaderProps {
  levels: Level[] | undefined
  loading: boolean | undefined
}

export const AccommodationAddHeader: React.FC<AccommodationAddHeaderProps> = ({
  levels,
  loading
}) => {
  const classes = useStyles()
  const params = useParams<{ accID: string }>()
  return (
    <div className={classes.header}>
      <AccommodationIcon fontSize="large" />
      {loading && params.accID ? (
        <AccommodationAddHeaderSkeleton />
      ) : (
        <Typography
          data-cy="addNewAccommodationOrEditAccommodation"
          className={classes.title}
          variant="h3"
          gutterBottom>
          {getTranslate(
            params.accID
              ? getTranslate(`${levels && levels[1].label}`)
              : getTranslate('Add New Accommodation')
          )}
        </Typography>
      )}
    </div>
  )
}
